import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <div className="mb-4">
              <Logo size="md" className="brightness-0 invert" />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              E-Ticaret satıcıları için yapay zeka destekli müşteri soruları yönetim platformu.
            </p>
            <p className="text-xs text-gray-500">
              Bir <span className="text-[#FF6000] font-semibold">Admosphere</span> iştiraki
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#FF6000] transition-colors">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-sm hover:text-[#FF6000] transition-colors">
                  Özellikler
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm hover:text-[#FF6000] transition-colors">
                  Fiyatlandırma
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-[#FF6000] transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Yasal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-[#FF6000] transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm hover:text-[#FF6000] transition-colors">
                  SSS
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm hover:text-[#FF6000] transition-colors">
                  Kullanım Koşulları
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm hover:text-[#FF6000] transition-colors">
                  KVKK Aydınlatma Metni
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">İletişim</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm">
                <Mail className="h-4 w-4 mt-0.5 text-[#FF6000]" />
                <span>info@aimerkur.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Phone className="h-4 w-4 mt-0.5 text-[#FF6000]" />
                <span>+90 (XXX) XXX XX XX</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 text-[#FF6000]" />
                <span>İstanbul, Türkiye</span>
              </li>
            </ul>
            
            {/* Social Media */}
            <div className="flex gap-3 mt-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-gray-800 hover:bg-[#FF6000] flex items-center justify-center transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-gray-800 hover:bg-[#FF6000] flex items-center justify-center transition-colors"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-gray-800 hover:bg-[#FF6000] flex items-center justify-center transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-gray-800 hover:bg-[#FF6000] flex items-center justify-center transition-colors"
              >
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-500">
            © {currentYear} AIMERKUR. Tüm hakları saklıdır. Bir Admosphere iştiraki.
          </p>
        </div>
      </div>
    </footer>
  );
}
